import React, {useRef, useEffect} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space} from 'antd';
import {getAll, drop} from '../../../../apis/MotivosBajaApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <ClockCircleFilled />
        <span>Motivos de Baja</span>
      </>
    ),
}];

const MotivosBajaPage = () => {
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);

    const columns = [
      {
        title: 'Clave',
        dataIndex: 'clave',
        key: 'clave',
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setPeriodSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el registro?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('El registro ha sido eliminado!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setPeriodSelected(null);
    }

    const onHandlerFinish = async (refresh,  avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
      }

      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp routes={routes}>
      <Button type="primary" onClick={btnClick}>
          Agregar Motivo de Baja
      </Button>
      <Divider/>
      {
          items.length == 0 ? <Empty />:
          <Table dataSource={items} columns={columns} />
      }
      {
        (openEdit && periodSelected && periodSelected.id > 0) &&
        <ModalEdit title={"Editar Motivo de Baja"} id={periodSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !periodSelected) &&
        <ModalEdit title={"Crear Motivo de Baja"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default MotivosBajaPage;
